"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arrow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var faLongArrowAltRight_1 = require("@fortawesome/pro-solid-svg-icons/faLongArrowAltRight");
var Arrow = function (_a) {
    var disabled = _a.disabled;
    return ((0, jsx_runtime_1.jsx)("li", __assign({ className: "mt-2" }, { children: (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-2xl " + (disabled ? "text-contentAreaBorder" : "text-secondary") }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faLongArrowAltRight_1.faLongArrowAltRight }, void 0) }), void 0) }), void 0));
};
exports.Arrow = Arrow;
